<template>
    <div class="my_consultation">
        <div class="search_box flex2">
            <form action="#" @submit.prevent="onSubmit">
            <input
                type="search"
                placeholder="搜索"
                class="search_input"
                v-model="keyWords"
                @keypress.enter="searchData"
            />
            </form>
            <div class="search_btn" @click="searchData">搜索</div>
        </div> 

<van-list
            v-model="loading"
            :finished="finished"
            finished-text="全部加载完毕"
            @load="getData"
            class="item_list"
          >
            <div class="item" v-for="item in dataList" :key="item.InquiryId">
              <img src="@/images/user_man.png" class="head_img" v-if="item.Sex==1" />
              <img src="@/images/user_woman.png" class="head_img" v-if="item.Sex==2" />
              <div class="detail">
                <div class="flex1">
                  <div class="flex2">
                    <div class="name flex2">
                      <div class="name_box line1">{{item.Name}}</div>
                      <div class="phone_box">{{item.PhoneNo}}</div>
                      <img src="@/images/pic.png" class="inquiry_type" v-if="item.ModeType==1" />
                      <img src="@/images/video_2.png" class="inquiry_type" v-if="item.ModeType==5" />
                    </div>
                  </div>
                  <div class="type" v-if="item.Status==1">等待接诊</div>
                  <div class="type" v-if="item.Status==3">接诊中</div>
                  <div class="type type2" v-if="item.Status==5">已开方</div>
                  <div class="type" v-if="item.Status==9">接诊中</div>
                  <div class="type color_red" v-if="item.Status==99">已拒绝</div>
                </div>
                <div class="flex2">
                  <div class="age">年龄：{{item.Age}}</div>
                  <div class="sex">性别：{{item.Sex==1?'男':'女'}}</div>
                </div>

                <div class="create_date">提交时间：{{item.CreateDate}}</div>
                <div class="flex2 more_btn">
                  <div v-if="item.Status==5" @click="continued(item.InquiryId)">续方</div>
                  <div v-show="item.Status==5" @click="gotoPreDetail(item)">查看处方</div>
                  <div
                    @click="showRefuse({tip:item.DealDesc,id:item.InquiryId})"
                    v-if="item.Status==99"
                  >拒绝原因</div>
                  <div @click="gotoInquiryDetail(item)">问诊详情</div>
                </div>
              </div>
            </div>
          </van-list>
    </div>
</template>
<script>
import navigationBar from "@/components/NavigationBar.vue";
import refuseTip from "@/components/refuseTip.vue";  
import { GetInquiryList, GetInquiry,GetInquiryHistoryList,GetAppInqDbList } from "@/utils/api.js";
import { getCookie } from "@/utils/common.js";
import { List, Toast,PullRefresh  } from "vant";
export default {
  components: {
    navigationBar,
    refuseTip
  },
  data() {
    return {
      inquiryStatus:"",
      app_mobile:"",
      isLoading2:false,
      isLoading:false,
      ModeType: 1,
      clear: true,
      finished: true,
      loading: false,
      reasonTip: "", //拒绝原因
      InquiryId: "",
      refuse: false,
      detail: {},
      woman: "@/images/user_woman.png",
      man: "@/images/user_man.png",
      dataList: [],
      keyWords: "",
      page: 1,

    };
  },

  methods: {
    gotoInquiryDetail(item) {

      this.$router.push({
        path: "/inquiryDetail",
        query: {
          InquiryId: item.InquiryId,
          status: item.Status,
          DealDesc: item.DealDesc
        }
      });
    },
    gotoPreDetail(item) {

      this.$router.push({
        path: "/prescriptionDetail",
        query: { InquiryId: item.InquiryId }
      });
    },


    onSubmit() {},
    searchData(values) {
      console.log("搜索");
      this.page = 1;
      this.dataList = [];
      // this.finished = false
      this.getData(values);
    },
    // 点击续方
    continued(id) {
      GetInquiry({
        AppKey: this.$store.state.AppKey,
        Token,
        InquiryId: id
      })
        .then(res => {
          if (res == "Again") {
            this.continued();
            return
          } else if (res.errcode == 0) {
            Toast.loading({
              message: "跳转中",
              duration: 0
            });
            let data = res.InquiryInfo;
            data.PicList.map(item => {
              item.content = item.Url;
            });
            let person = [
              { text: "", tip: "name" },
              { text: "", tip: "carId" },
              { text: "", tip: "bornDate" },
              { text: "", tip: "sex" },
              { text: "", tip: "phone" },
              {
                text: "",
                tip: "about",
                testList: [
                  { name: "", title: "过往病史" },
                  { name: "", title: "过敏史" },
                  { name: "", title: "家族病史" },
                  { name: "", title: "妊娠哺乳" },
                  { name: "", title: "肝功能" },
                  { name: "", title: "肾功能" }
                ]
              }
            ];
            let hsitoryDisList = [
              {
                type: 0,
                name: "过往病史",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "先天性心脏病", sel: false, sys: true },
                  { name: "阴道炎", sel: false, sys: true },
                  { name: "月经失调", sel: false, sys: true },
                  { name: "肿瘤", sel: false, sys: true },
                  { name: "动脉硬化", sel: false, sys: true },
                  { name: "脑血管病", sel: false, sys: true },
                  { name: "糖尿病", sel: false, sys: true }
                ],
                showAdd: true
              },
              {
                type: 1,
                name: "过敏史",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "青霉素", sel: false, sys: true },
                  { name: "动物皮屑", sel: false, sys: true },
                  { name: "尘螨", sel: false, sys: true },
                  { name: "灰尘", sel: false, sys: true },
                  { name: "花粉", sel: false, sys: true },
                  { name: "鸡蛋", sel: false, sys: true },
                  { name: "牛奶", sel: false, sys: true },
                  { name: "鱼,虾,海产品", sel: false, sys: true },
                  { name: "阿司匹林", sel: false, sys: true }
                ],
                showAdd: true
              },
              {
                type: 2,
                name: "家族病史",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "先天性心脏病", sel: false, sys: true },
                  { name: "阴道炎", sel: false, sys: true },
                  { name: "月经失调", sel: false, sys: true },
                  { name: "肿瘤", sel: false, sys: true },
                  { name: "动脉硬化", sel: false, sys: true },
                  { name: "脑血管病", sel: false, sys: true },
                  { name: "糖尿病", sel: false, sys: true }
                ],
                showAdd: true
              },
              {
                type: 3,
                name: "妊娠哺乳",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "备孕中", sel: false, sys: true },
                  { name: "怀孕中", sel: false, sys: true },
                  { name: "正在哺乳", sel: false, sys: true }
                ],
                showAdd: false
              },
              {
                type: 4,
                name: "肝功能",
                radio: "0",
                text1: "异常",
                text2: "正常",
                medList: [],
                showAdd: false
              },

              {
                type: 5,
                name: "肾功能",
                radio: "0",
                text1: "异常",
                text2: "正常",
                medList: [],
                showAdd: false
              }
            ];
            person[0].text = data.Name;
            person[1].text = data.IDCard;
            person[2].text = data.Birthdate;
            person[3].text = data.Sex == 1 ? "男" : "女";
            person[4].text = data.PhoneNo;
            person[5].text = "";

            hsitoryDisList[0].radio = data.PMHType;
            hsitoryDisList[1].radio = data.AMHType;
            hsitoryDisList[2].radio = data.FMHType;
            hsitoryDisList[3].radio = data.NurseType;
            hsitoryDisList[4].radio = data.LiverType;
            hsitoryDisList[5].radio = data.RenalType;
            // hsitoryDisList.map(item=>{
            //   if(item.radio==1){
            //     person[5].text+=item.name+","
            //   }
            // })
            // person[5].text=person[5].text.substring(0,person[5].text.length-1)

            data.DiseaseList.map(item => {
              item.sel = true;
            });
            data.DrugsList.map(item => {
              item.num = item.Count;
            });

            person[5].testList[0].name = data.PMH || "";
            person[5].testList[1].name = data.AMH || "";
            person[5].testList[2].name = data.FMH || "";
            person[5].testList[3].name = data.NurseDesc || "";
            person[5].testList[4].name = data.LiverDesc || "";
            person[5].testList[5].name = data.RenalDesc || "";
            hsitoryDisList.map((item, index) => {
              let temArr = [];
              let arr = person[5].testList[index].name.split("、");
              item.medList.map((it, inx) => {
                arr.map((items, indexs) => {
                  if (items == it.name) {
                    it.sel = true;
                  }
                });
              });
              // 判断返回的值是否存在不是系统默认的值
              arr.map((items, indexs) => {
                let count = item.medList.every((it, inx) => {
                  return items != it.name;
                });
                if (count) {
                  temArr.push({
                    sys: false,
                    sel: true,
                    name: items
                  });
                  temArr.map(items3 => {
                    if (items3.name) {
                      item.medList.push(items3);
                    }
                  });
                }
              });
            });
            let onlyDrugsList = data.DiseaseList.filter(item => {
              item.isMain == 1;
            });
            if (onlyDrugsList[0]) {
              if (onlyDrugsList[0].DiseaseList.length > 0) {
                onlyDrugsList[0].DiseaseList.map(item => {
                  data.DiseaseList.map(items => {
                    if (item.Name == items.Name) {
                      items.sys = true;
                    }
                  });
                });
              }
            }
            let str = "";
            hsitoryDisList.map((item, index) => {
              if (item.radio == 1) {
                if (index == 4 || index == 5) {
                  str += item.name + "异常、";
                } else {
                  str += "有" + item.name + "、";
                }
              }
            });
            if (str == "") {
              person[5].text = "无";
            } else {
              person[5].text = str.substring(0, str.length - 1);
            }

            sessionStorage.setItem(
              "fillData",
              JSON.stringify({
                currentDate: data.Birthdate,
                diseaseList: data.DiseaseList,
                imgList: data.PicList,
                description: data.SymptomDesc,
                addDrugsList: data.DrugsList,
                hsitoryDisList,
                person,
                weight: data.Weight
              })
            );
            sessionStorage.setItem("firstHis", true);
            console.log(213);
            Toast.clear();
            this.clear = false;
            console.log(JSON.parse(sessionStorage.getItem("fillData")));
            this.$router.push({ path: "/fill", query: { type: "keep",ModeType: data.ModeType} });
          } else {
            Toast("请求错误，请稍后再试");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 显示拒绝原因
    showRefuse(data) {
      this.reasonTip = data.tip;
      this.InquiryId = data.id;
      this.refuse = true;
      this.ModeType = data.ModeType;
    },
    // 请求列表
    getData(values) {
      console.log("列表请求");

      let interfaces = this.inquiryStatus==1?GetAppInqDbList:GetInquiryList
      interfaces({
        Page: this.page,
        PageSize: 10,
        Search: this.keyWords
      }).then(res => {
        if (res == "Again") {
          this.getData();
          return;
        }
        if (res.errcode == 0) {
          if(values){
            this.isLoading = false
            this.dataList = []
          }
          
          this.dataList = [...this.dataList, ...res.InquiryList];
          this.page += 1;
          this.loading = false;
          if (this.dataList.length >= res.PageTotal) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          Toast(res.errmsg);
        }
        this.loading = false;
      });
    },

  },
  mounted() {
      this.inquiryStatus = this.$route.query.inquiryStatus
      
  },
};
</script>
<style scoped lang="scss"  src="@/scss/my-consultation.scss">

</style>